var TableModule = /** @class */ (function () {
    function TableModule() {
    }
    return TableModule;
}());
export { TableModule };
